import Credentials from './credentials';

export default class TopicCredentials extends Credentials {
  get topic() {
    return this.credentials.topics[0];
  }
}
